import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { SuccessAnimationView } from './SuccessAnimationView';

export const SuccessAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    return <SuccessAnimationView uid={widget.uid} margin={widget.options?.margin} />;
};
